import { useState, useCallback } from 'react';

export const useAuth = (navigate) => {
    const [authError, setAuthError] = useState('');

    const checkAuth = useCallback(() => {
        const adminToken = localStorage.getItem('adminToken');
        const adminUser = localStorage.getItem('adminUser');

        if (!adminToken || !adminUser) {
            setAuthError('No authentication found');
            navigate('/login', { replace: true });
            return false;
        }

        if (!adminToken.startsWith('admin_session_')) {
            setAuthError('Invalid token format');
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            navigate('/login', { replace: true });
            return false;
        }

        try {
            const base64 = adminToken.replace('admin_session_', '');
            const decoded = atob(base64);
            const tokenData = JSON.parse(decoded);

            const now = Math.floor(Date.now() / 1000);
            if (tokenData.exp < now) {
                setAuthError('Token expired');
                localStorage.removeItem('adminToken'); // Fixed the typo here
                localStorage.removeItem('adminUser');
                navigate('/login', { replace: true });
                return false;
            }

            return true;
        } catch (err) {
            setAuthError('Token validation failed');
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            navigate('/login', { replace: true });
            return false;
        }
    }, [navigate]);

    return { authError, setAuthError, checkAuth };
};